import { useEffect, useState } from "react";
import { Clock, Headphones, Download, Share2 } from "lucide-react";

const getLessonId = (lesson) =>
  lesson?.id || lesson?._id || lesson?.vimeoVideoId || lesson?.vimeoVideoUri;
const formatDuration = (duration) => {
  if (typeof duration !== "number") return duration;

  const minutes = Math.floor(duration / 60);
  const seconds = String(duration % 60).padStart(2, "0");
  return `${minutes}:${seconds}`;
};

export const VideoPlayer = ({ lesson }) => {
  const [loading, setLoading] = useState(true);
  const lessonId = getLessonId(lesson);

  const appendParams = (url = "") => {
    if (!url) return "";

    const separator = url.includes("?") ? "&" : "?";

    return `${url}${separator}title=0&byline=0&portrait=0&badge=0&dnt=1`;
  };

  const videoSrc =
    lesson?.embedUrl
      ? appendParams(lesson.embedUrl)
      : lesson?.vimeoVideoId
      ? appendParams(`https://player.vimeo.com/video/${lesson.vimeoVideoId}`)
      : appendParams(`https://player.vimeo.com/video/${lesson?.vimeoId}`);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(t);
  }, [lessonId]);

  if (!lesson) return null;

  return (
    <div data-testid="video-player-area" className="fade-up">
      {/* Video frame */}
      <div className="relative aspect-video rounded-2xl overflow-hidden ring-1 ring-white/10 bg-[#0A0A0C] shadow-[0_30px_80px_-30px_rgba(0,0,0,0.8)]">
        {loading ? (
          <div className="absolute inset-0 skeleton flex items-center justify-center">
            <div className="w-14 h-14 rounded-full bg-white/[0.03] border border-white/[0.06] flex items-center justify-center">
              <Headphones className="w-6 h-6 text-[#C5A059] opacity-60" strokeWidth={1.5} />
            </div>
          </div>
        ) : (
          <iframe
            key={lessonId}
            data-testid={`video-iframe-${lessonId}`}
            src={videoSrc}
            title={lesson.title}
            className="w-full h-full"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>

      {/* Meta */}
      <div className="mt-8 md:mt-10 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-[#C5A059] font-semibold">
            <span>Lesson</span>
            <span className="w-1 h-1 rounded-full bg-[#C5A059]/50" />
            <span className="text-zinc-500 normal-case tracking-normal flex items-center gap-1">
              <Clock className="w-3 h-3" strokeWidth={2} />
              {formatDuration(lesson.duration)}
            </span>
          </div>
          <h1
            data-testid="lesson-title"
            className="mt-3 font-heading text-3xl md:text-4xl font-semibold text-white tracking-tight leading-[1.1]"
          >
            {lesson.title}
          </h1>
          <p
            data-testid="lesson-description"
            className="mt-5 text-zinc-400 text-base md:text-lg leading-relaxed font-light"
          >
            {lesson.description || ""}
          </p>
        </div>

        {/* <div className="flex items-center gap-2 flex-shrink-0">
          <button
            data-testid="lesson-download"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white/[0.04] border border-white/10 text-sm text-zinc-200 hover:bg-white/[0.08] transition-all"
          >
            <Download className="w-3.5 h-3.5" strokeWidth={1.7} />
            Session
          </button>
          <button
            data-testid="lesson-share"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/[0.04] border border-white/10 text-zinc-200 hover:bg-white/[0.08] transition-all"
            aria-label="Share lesson"
          >
            <Share2 className="w-3.5 h-3.5" strokeWidth={1.7} />
          </button>
        </div> */}
      </div>

      {/* Lesson notes / chapter markers */}
      {/* <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { label: "Chapter 1", time: "00:00", title: "Introduction" },
          { label: "Chapter 2", time: "03:14", title: "The technique" },
          { label: "Chapter 3", time: "07:42", title: "Recap & exercise" },
        ].map((c, i) => (
          <div
            key={i}
            data-testid={`chapter-${i}`}
            className="rounded-2xl border border-white/[0.06] bg-white/[0.015] p-5 hover:border-white/[0.14] hover:bg-white/[0.03] transition-all cursor-pointer"
          >
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#C5A059] font-semibold">
              {c.label}
            </div>
            <div className="mt-2 font-heading text-base text-white font-medium">
              {c.title}
            </div>
            <div className="text-xs text-zinc-500 mt-1">{c.time}</div>
          </div>
        ))}
      </div> */}
    </div>
  );
};
